<script setup>
const corePrompt = ref();

// provide the prompt function to all descendants
provide("$interactions", corePrompt);
</script>

<template>
  <v-app class="bg-blue-grey-lighten-5">
    <dashboard-navbar />
    <v-main class="bg-blue-grey-lighten-5">
      <v-container fluid>
        <v-row>
          <v-col>
            <slot />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <CoreSnackbar />
    <CorePrompt ref="corePrompt" />
  </v-app>
</template>

<style scoped></style>
